/**
 * Single source of truth for the "Brain completeness" score (B1 roadmap #5).
 *
 * Exactly 7 brand-identity fields count toward the score — the same model
 * the Help center teaches ("Fill in all 7 fields to reach 100% Brain
 * health"). Three surfaces render the number and must always agree:
 *
 *   - Sidebar nav badge          (main.js updateBrainScore)
 *   - Command Center ring        (pages/home.js "Brand Intelligence" card)
 *   - Brain page header badge    (pages/memory.js getBrainHealth)
 *
 * Before this helper existed each surface hand-rolled its own denominator
 * (7 fields vs two different 8-item checklists), so a new user saw two
 * different zero-percent scores that meant almost the same thing.
 *
 * Accepts a brand-profile-shaped object; values may be raw strings (from
 * /api/memory or /api/dashboard/summary) — blank/whitespace-only strings
 * do not count as filled.
 */

export const BRAIN_SCORE_FIELDS = [
    'mission',
    'audience',
    'voice',
    'offers_summary',
    'cta',
    'keywords',
    'avoid_words',
];

export function computeBrainScore(profile) {
    const p = profile || {};
    const filled = BRAIN_SCORE_FIELDS.filter((key) => {
        const v = p[key];
        return typeof v === 'string' ? v.trim().length > 0 : !!v;
    }).length;
    const total = BRAIN_SCORE_FIELDS.length;
    return { filled, total, pct: Math.round((filled / total) * 100) };
}
